import FooterComponent from "../components/FooterComponent"
import HeaderComponent from "../components/HeaderComponent"
import TermsComponent from "../components/TermsComponent"


const TermsPage = () => {
    return (
        <>
            <HeaderComponent/>
            <TermsComponent/>
            <FooterComponent/>
        </>
    )
}

export default TermsPage